export class PitrRestoreWindowsResponse {
    'vaults';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaults",
            "baseName": "vaults",
            "type": "Array<PitrRestoreVaultWindows>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PitrRestoreWindowsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
